import isValidRegex from '@kentik/ui-shared/validators/isValidRegex';

export default {
  message: 'This field must contain a valid regular expression',
  fn: isValidRegex
};
